import React from 'react';
import { motion } from 'framer-motion';
import { ScrollVelocity } from './ScrollVelocity';

const Skills = () => {
  const services = [
    {
      title: "Custom Website Design",
      description: "Modern, clean UI/UX designed around your brand identity—not templates. Focus on visual impact and usability."
    },
    {
      title: "Advanced Visual Experiences",
      description: "Scroll-story websites, animated transitions, interactive elements that guide attention. Cinematic flows, not static pages."
    },
    {
      title: "Client-Collaborative Design",
      description: "Be fully involved step-by-step, or delegate completely. We adapt to your preferred level of involvement."
    },
    {
      title: "Website Deployment",
      description: "Final website setup, publishing, and optimization for performance. Your site goes live smoothly."
    },
    {
      title: "SEO & Ranking",
      description: "Optional growth add-ons: SEO setup, ranking optimization to get your site discovered."
    },
    {
      title: "Ongoing Maintenance",
      description: "Continuous updates, improvements, and support to keep your website fresh and performing at its best."
    }
  ];

  const strengths = [
    "Strong visual intuition",
    "Translate 'vibe' into design",
    "Close client collaboration",
    "AI-powered rapid execution",
    "Scroll animations",
    "Interactive elements",
    "Cinematic storytelling",
    "Brand-focused design"
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <section className="skills-section" id="skills">
      <div className="skills-container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.8 }}
        >
          WHAT WE DO
        </motion.h2>
        
        <motion.div 
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-10%" }}
        >
          {services.map((service, index) => (
            <motion.div key={index} className="service-card" variants={itemVariants}>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>

        <div className="technologies-section">
          <motion.h3 
            className="technologies-heading"
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6 }}
          >
            Our Real Strengths
          </motion.h3>
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-10%" }}
            style={{ width: "100%", overflow: "hidden", paddingTop: "1rem" }}
          >
            <ScrollVelocity 
              texts={[
                <div style={{ display: 'flex', gap: '1rem', paddingRight: '1rem' }}>
                  {strengths.slice(0, 4).map((strength, index) => (
                    <div key={index} className="tech-badge" style={{ margin: 0, opacity: 1, transform: 'none' }}>
                      <span className="tech-name">{strength}</span>
                    </div>
                  ))}
                </div>,
                <div style={{ display: 'flex', gap: '1rem', paddingRight: '1rem' }}>
                  {strengths.slice(4).map((strength, index) => (
                    <div key={index} className="tech-badge" style={{ margin: 0, opacity: 1, transform: 'none' }}>
                      <span className="tech-name">{strength}</span>
                    </div>
                  ))}
                </div>
              ]}
              velocity={50}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
